import { render, staticRenderFns } from "./detail-apport-header.vue?vue&type=template&id=52293ef3&scoped=true"
import script from "./detail-apport-header.vue?vue&type=script&lang=js"
export * from "./detail-apport-header.vue?vue&type=script&lang=js"
import style0 from "./detail-apport-header.vue?vue&type=style&index=0&id=52293ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52293ef3",
  null
  
)

export default component.exports